<template>
    <flex-container
        :padding="Size.md"
        :gap="Size.sm"
        :color="Color.gray200"
        no-wrap
    >
        <virtual-colleague-avatar
            :variant="currentLegacyCompany.virtualColleagueAvatar ?? 'avatar1' "
            class="virtual-colleague-avatar"
            size="xxl"
        />
        <text-description
            class="virtual-colleague-message"
            :color="Color.gray800"
        >
            <text-decorator
                :color="Color.brandPink"
                bold
            >
                {{ currentLegacyCompany.virtualColleagueName ?? 'Emma' }}
            </text-decorator>
            <br>
            <slot />
        </text-description>
    </flex-container>
</template>

<script setup lang="ts">
    import { Color, VirtualColleagueAvatar, Size } from '@keyvue/one-ui';
    import useClient from '@composables/useClient';

    const { currentLegacyCompany } = useClient();
</script>

<style scoped lang="scss">
.virtual-colleague-avatar {
    flex-shrink: 0;
}
.virtual-colleague-message {
    width: 1fr;
    flex-shrink: 1;
}
</style>
